import { cacheKeys } from "@constants/cache-keys";
import { trackAnswerEvent } from "@features/session/api/mutations";
import type { TrackAnswerEventRequest } from "@features/session/api/types";
import useSessionStore from "@features/session/hooks/useSessionStore";
import useCacheKey from "@hooks/useCacheKey";
import { useMutation } from "@tanstack/react-query";

const useAnswerEvent = () => {
	const { baseCacheKey } = useCacheKey();

	const updateAnswerEventInProgress = useSessionStore(
		(state) => state.updateAnswerEventInProgress,
	);
	const mutation = useMutation({
		mutationKey: [baseCacheKey, cacheKeys.answerEvent],
		retry: 3,
		retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
		mutationFn: (data: { answerEventPayload: TrackAnswerEventRequest }) => {
			updateAnswerEventInProgress(true);
			return trackAnswerEvent(data.answerEventPayload);
		},
	});

	return {
		mutateTrackAnswerEvent: mutation.mutate,
		isTrackingAnswerEvent: mutation.isPending,
	};
};

export default useAnswerEvent;
